<div class="bulk-import-container" fxLayout="column" fxLayoutAlign="start">
  <app-import-guide
    [guideList]="guideList"
  ></app-import-guide>
</div>
